<script setup>
/**
 * A group of what an element of the catalogue is related to (D-280): its name, how many, the list —
 * and what being on it means (`tip`, D-310): shown over its heading's ⓘ and over the list.
 */
defineProps({
  title: { type: String, required: true },
  icon: { type: String, default: '' },
  count: { type: Number, default: null },
  hint: { type: String, default: '' },
  tip: { type: String, default: '' },
  empty: Boolean,
  // The tip over the list too (a list read, not one edited row by row).
  listTip: { type: Boolean, default: true },
})
</script>

<template>
  <section class="card text-sm">
    <header class="flex items-center gap-2 border-b border-default px-4 py-2">
      <i v-if="icon" :class="['fa-solid fa-fw text-faint', icon]" aria-hidden="true"></i>
      <h2 class="flex-1 font-semibold">{{ title }}<span v-if="count !== null" class="ml-1 font-normal text-muted">({{ count }})</span>
        <i v-if="tip" class="fa-solid fa-circle-info ml-1 cursor-help text-xs text-faint" :title="tip" :aria-label="tip" role="img" data-testid="related-tip"></i></h2>
      <slot name="actions" />
    </header>
    <p v-if="hint" class="px-4 pt-2 text-xs text-muted">{{ hint }}</p>
    <p v-if="empty" class="px-4 py-2 text-faint">—</p>
    <div v-else :title="(listTip && tip) || null"><slot /></div>
  </section>
</template>
